"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HashtagLink = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const button_styles_1 = require("@/components/common/button/button.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let HashtagLink = class HashtagLink extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
    }
    render() {
        return (0, lit_1.html) `
      <a href=${this.href}>
        <slot></slot>
      </a>
    `;
    }
};
HashtagLink.styles = [
    shared_styles_1.resetStyles,
    button_styles_1.buttonBaseStyles,
    (0, lit_1.css) `
      a {
        gap: 0;
        text-transform: none;
      }

      a::before {
        content: '#';
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], HashtagLink.prototype, "href", void 0);
HashtagLink = __decorate([
    (0, decorators_js_1.customElement)('mm-hashtag-link')
], HashtagLink);
exports.HashtagLink = HashtagLink;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFzaHRhZy1saW5rLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaGFzaHRhZy1saW5rLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsNEVBQTJFO0FBQzNFLCtEQUF5RDtBQUdsRCxJQUFNLFdBQVcsR0FBakIsTUFBTSxXQUFZLFNBQVEsZ0JBQVU7SUFBcEM7O1FBZXVCLFNBQUksR0FBRyxFQUFFLENBQUE7SUFTdkMsQ0FBQztJQVBDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBO2dCQUNDLElBQUksQ0FBQyxJQUFJOzs7S0FHcEIsQ0FBQTtJQUNILENBQUM7O0FBdEJNLGtCQUFNLEdBQUc7SUFDZCwyQkFBVztJQUNYLGdDQUFnQjtJQUNoQixJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7O0tBU0Y7Q0FDRixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt5Q0FBVTtBQWYxQixXQUFXO0lBRHZCLElBQUEsNkJBQWEsRUFBQyxpQkFBaUIsQ0FBQztHQUNwQixXQUFXLENBd0J2QjtBQXhCWSxrQ0FBVyJ9